import { render } from "./more-loading.vue?vue&type=template&id=b0adf1f4&ts=true"
import script from "./more-loading.vue?vue&type=script&lang=ts"
export * from "./more-loading.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__